// extracted by mini-css-extract-plugin
export default {"heading":"ServicesPageContent_heading__Z6Bn9","smallTextSize":"ServicesPageContent_smallTextSize__qJzm3","mediumTextSize":"ServicesPageContent_mediumTextSize__UmO-R"};